import { Text, View, type TextProps } from "react-native";
import { cn } from "@/shared/lib/utils";

const variantClasses: Record<string, string> = {
  display:
    "font-display text-foreground text-3xl font-bold tracking-tight leading-tight",
  screen: "font-display text-foreground text-2xl font-semibold tracking-tight",
  section: "font-display text-foreground text-xl font-semibold",
  card: "font-display text-foreground text-lg font-semibold",
};

const kickerToneClasses: Record<string, string> = {
  brand: "text-brand",
  pink: "text-pink",
};

type HeadingProps = TextProps & {
  variant: "display" | "screen" | "section" | "card";
  kicker?: string;
  kickerTone?: "brand" | "pink";
  className?: string;
};

export function Heading({
  variant,
  kicker,
  kickerTone = "pink",
  className,
  children,
  ...rest
}: HeadingProps) {
  const headingEl = (
    <Text className={cn(variantClasses[variant], className)} {...rest}>
      {children}
    </Text>
  );

  if (variant === "display" && kicker) {
    return (
      <View>
        <Text
          className={cn(
            "mb-1 text-xs font-semibold tracking-widest uppercase",
            kickerToneClasses[kickerTone]
          )}
          accessibilityElementsHidden
          importantForAccessibility="no"
        >
          {kicker}
        </Text>
        {headingEl}
      </View>
    );
  }

  return headingEl;
}
